import React from "react"
import CustomButton from "../../../../../ui/atoms/Button"
import { useLabels } from "../../../../contents/hooks"
import { useRecaptchaValidation } from "../../../../recaptcha"

interface Props {
  loading: boolean
  onSubmit: () => void
}

const EventCalendarSubmitButton = ({ loading, onSubmit }: Props) => {
  const { getLabel } = useLabels()
  const { execute } = useRecaptchaValidation()

  const handleSubmit = async () => {
    const validation = execute()
    if (!validation.valid) {
      return
    }

    onSubmit()
  }

  return (
    <CustomButton loading={loading} onClick={handleSubmit}>
      {getLabel("calendar", "confirm-label")}
    </CustomButton>
  )
}

export default EventCalendarSubmitButton
